export const AUTH_TOKEN_KEY = 'auth-token'
export const REFRESH_TOKEN_KEY = 'auth-refresh-token'
export const IMPERSONATION_QUERY_KEY = 'imp-redirect-to'
export const IMPERSONATION_TOKEN_KEY = 'impersonation-user-token'
